// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__oCZfO","emergency":"styles_emergency__RRX-H","normal":"styles_normal__9Lh+m"};